"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadList = downloadList;
exports.download = download;
exports.authDownload = authDownload;
exports.authDownloadAll = authDownloadAll;
exports.downloadAll = downloadAll;
exports.createUpload = createUpload;
exports.uploadPart = uploadPart;
exports.fetchUpload = fetchUpload;
exports.deleteUpload = deleteUpload;
exports.endpoints = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _set = _interopRequireDefault(require("lodash/set"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _utils2 = require("../utils");

var _qs = _interopRequireDefault(require("qs"));

var endpoints = {
  downloadList: {
    method: 'GET',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/").concat(_utils2.NOAUTH_PREFIX, "/large_attachment/download/list");
    }
  },
  download: {
    method: 'GET',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/").concat(_utils2.NOAUTH_PREFIX, "/large_attachment/download");
    }
  },
  authDownload: {
    method: 'GET',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/large_attachment/authdownload");
    }
  },
  authDownloadAll: {
    method: 'GET',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/large_attachment/authdownloadall");
    }
  },
  downloadAll: {
    method: 'GET',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/").concat(_utils2.NOAUTH_PREFIX, "/large_attachment/downloadall");
    }
  },
  create: {
    method: 'POST',
    url: function url() {
      return "".concat(_utils2.UPLOAD_SERVER, "/").concat(_utils2.API_V1, "/attachment");
    }
  },
  uploadPart: {
    method: 'POST',
    url: function url(attachmentId, seq, hash) {
      return "".concat(_utils2.UPLOAD_SERVER, "/").concat(_utils2.API_V1, "/attachment/").concat(attachmentId, "/").concat(seq, "?hash=").concat(hash);
    }
  },
  fetch: {
    method: 'GET',
    url: function url(attachmentId) {
      return "".concat(_utils2.UPLOAD_SERVER, "/").concat(_utils2.API_V1, "/attachment/").concat(attachmentId);
    }
  },
  "delete": {
    method: 'DELETE',
    url: function url(attachmentId) {
      return "".concat(_utils2.UPLOAD_SERVER, "/").concat(_utils2.API_V1, "/attachment/").concat(attachmentId);
    }
  }
};
exports.endpoints = endpoints;

/**
 * Get large attachment list
 *
 * @public
 * @returns {Promise<DownloadListResponse>}
 */
function downloadList(_x) {
  return _downloadList.apply(this, arguments);
}
/**
 * Get large attachment link
 *
 * @public
 * @returns {string}
 */


function _downloadList() {
  _downloadList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var password, mid, email, uid, optionals, _endpoints$downloadLi, method, url, res;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            password = _ref.password, mid = _ref.mid, email = _ref.email, uid = _ref.uid;
            optionals = (0, _functools.compose)((0, _requests.withParams)({
              password: password,
              mid: mid,
              email: email,
              uid: uid
            }))(_utils.defaultOptionals);
            _endpoints$downloadLi = endpoints.downloadList, method = _endpoints$downloadLi.method, url = _endpoints$downloadLi.url;
            _context.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _downloadList.apply(this, arguments);
}

function download(_ref2) {
  var password = _ref2.password,
      mid = _ref2.mid,
      aid = _ref2.aid,
      uid = _ref2.uid,
      email = _ref2.email,
      action = _ref2.action,
      pvformat = _ref2.pvformat;

  if (action === 'preview') {
    var optionals = (0, _functools.compose)((0, _requests.withParams)({
      password: password,
      mid: mid,
      aid: aid,
      action: action,
      uid: uid,
      email: email,
      pvformat: pvformat
    }))(_utils.defaultOptionals);
    var _endpoints$download = endpoints.download,
        url = _endpoints$download.url,
        method = _endpoints$download.method;
    return (0, _requests.request)(url(), method, optionals);
  } else {
    return "".concat(endpoints.download.url(), "?").concat(_qs["default"].stringify({
      password: password,
      mid: mid,
      aid: aid,
      uid: uid,
      email: email,
      action: action
    }));
  }
}

function authDownload(_ref3, _ref4) {
  var mid = _ref3.mid,
      aid = _ref3.aid,
      uid = _ref3.uid,
      email = _ref3.email,
      action = _ref3.action,
      pvformat = _ref3.pvformat,
      imgsize = _ref3.imgsize;
  var auth = _ref4.auth;
  var _endpoints$authDownlo = endpoints.authDownload,
      url = _endpoints$authDownlo.url,
      method = _endpoints$authDownlo.method;

  if (action === 'preview') {
    var optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
      mid: mid,
      aid: aid,
      uid: uid,
      email: email,
      action: action,
      pvformat: pvformat
    }))(_utils.defaultOptionals);
    return (0, _requests.request)(url(), method, optionals);
  } else {
    var _optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);

    return fetch("".concat(endpoints.authDownload.url(), "?").concat(_qs["default"].stringify({
      mid: mid,
      aid: aid,
      uid: uid,
      email: email,
      action: action,
      imgsize: imgsize
    })), _optionals);
  }
}

function authDownloadAll(_ref5, _ref6) {
  var mid = _ref5.mid,
      uid = _ref5.uid,
      email = _ref5.email,
      action = _ref5.action;
  var auth = _ref6.auth;

  if (action === 'preview') {
    var optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
      mid: mid,
      uid: uid,
      email: email,
      action: action
    }))(_utils.defaultOptionals);
    var _endpoints$authDownlo2 = endpoints.authDownloadAll,
        url = _endpoints$authDownlo2.url,
        method = _endpoints$authDownlo2.method;
    return (0, _requests.request)(url(), method, optionals);
  } else {
    return "".concat(endpoints.authDownloadAll.url(), "?").concat(_qs["default"].stringify({
      mid: mid,
      uid: uid,
      email: email,
      action: action
    }));
  }
}
/**
 * Get large attachment download all link
 *
 * @public
 * @returns {string}
 */


function downloadAll(_ref7) {
  var password = _ref7.password,
      mid = _ref7.mid,
      uid = _ref7.uid,
      email = _ref7.email,
      action = _ref7.action;

  if (action === 'preview') {
    var optionals = (0, _functools.compose)((0, _requests.withParams)({
      mid: mid,
      uid: uid,
      email: email,
      action: action,
      password: password
    }))(_utils.defaultOptionals);
    var _endpoints$downloadAl = endpoints.downloadAll,
        url = _endpoints$downloadAl.url,
        method = _endpoints$downloadAl.method;
    return (0, _requests.request)(url(), method, optionals);
  } else {
    return "".concat(endpoints.downloadAll.url(), "?").concat(_qs["default"].stringify({
      password: password,
      mid: mid,
      uid: uid,
      email: email,
      action: action
    }));
  }
}

/**
 *  Create a large attachment upload session.
 * @public
 * @param {string} name - attachment name
 * @param {number} size - attachment size
 * @param {string} contentType - attachment content type
 * @param {Auth} auth - User authentication info
 * @returns {CreateUploadResponse}
 */
function createUpload(_x2, _x3) {
  return _createUpload.apply(this, arguments);
}

function _createUpload() {
  _createUpload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref8, _ref9) {
    var name, size, contentType, auth, optionals, _endpoints$create, method, url, res;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            name = _ref8.name, size = _ref8.size, contentType = _ref8.contentType;
            auth = _ref9.auth;
            optionals = (0, _functools.compose)((0, _requests.withBody)({
              name: name,
              size: size,
              contentType: contentType
            }), (0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$create = endpoints.create, method = _endpoints$create.method, url = _endpoints$create.url;
            _context2.next = 6;
            return (0, _requests.request)(url(), method, optionals);

          case 6:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createUpload.apply(this, arguments);
}

/**
 *  For an attachment part uploading, body size is limited to 8 MB.
 * @public
 * @param {string} attachmentId - Attachment Id
 * @param {number} seq - part seq number
 * @param {Blob} blobData - AttachmentPart Blob
 * @param {Auth} auth - User authentication info
 * @returns {UploadPartResponse}
 */
function uploadPart(_x4, _x5, _x6) {
  return _uploadPart.apply(this, arguments);
}

function _uploadPart() {
  _uploadPart = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref10, _ref11, progressEvents) {
    var aid, seq, blobData, hash, auth, signal, _endpoints$uploadPart, method, url, xhr, headers, key, header, promise;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            aid = _ref10.aid, seq = _ref10.seq, blobData = _ref10.blobData, hash = _ref10.hash;
            auth = _ref11.auth, signal = _ref11.signal;
            _endpoints$uploadPart = endpoints.uploadPart, method = _endpoints$uploadPart.method, url = _endpoints$uploadPart.url;
            xhr = new XMLHttpRequest();
            headers = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals).headers;

            if (progressEvents) {
              for (key in progressEvents) {
                (0, _set["default"])(xhr, key, progressEvents[key]);
              }
            }

            xhr.timeout = 60000;
            xhr.open(method, url(aid, seq, hash));

            for (header in headers) {
              xhr.setRequestHeader(header, headers[header]);
            }

            promise = new Promise(function (resolve, reject) {
              xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                  try {
                    var result = JSON.parse(xhr.responseText);

                    if (xhr.status === 200 && result.status === 200) {
                      resolve(result);
                    } else {
                      reject(new _requests.RequestError(result.message, result.status, result.status));
                    }
                  } catch (e) {
                    reject(new _requests.RequestError(xhr.statusText, xhr.status, xhr.status));
                  }
                }
              };

              xhr.onerror = function (error) {
                return reject(error);
              };

              xhr.ontimeout = function (error) {
                return reject(error);
              };
            });
            promise.xhr = xhr;
            xhr.send(blobData);
            return _context3.abrupt("return", promise);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _uploadPart.apply(this, arguments);
}

/**
 *  Get large attachment upload session info
 * @public
 * @param {string} attachmentId - Attachment Id
 * @param {Auth} auth - User authentication info
 * @returns {FetchUploadResponse}
 */
function fetchUpload(_x7, _x8) {
  return _fetchUpload.apply(this, arguments);
}

function _fetchUpload() {
  _fetchUpload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(attachmentId, auth) {
    var optionals, _endpoints$fetch, method, url, res;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$fetch = endpoints.fetch, method = _endpoints$fetch.method, url = _endpoints$fetch.url;
            _context4.next = 4;
            return (0, _requests.request)(url(attachmentId), method, optionals);

          case 4:
            res = _context4.sent;
            return _context4.abrupt("return", res);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchUpload.apply(this, arguments);
}

/**
 *  Delete large attachment upload session info
 * @public
 * @param {string} attachmentId - Attachment Id
 * @param {Auth} auth - User authentication info
 * @returns {DeleteUploadResponse}
 */
function deleteUpload(_x9, _x10) {
  return _deleteUpload.apply(this, arguments);
}

function _deleteUpload() {
  _deleteUpload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(attachmentId, auth) {
    var optionals, _endpoints$delete, method, url, res;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$delete = endpoints["delete"], method = _endpoints$delete.method, url = _endpoints$delete.url;
            _context5.next = 4;
            return (0, _requests.request)(url(attachmentId), method, optionals);

          case 4:
            res = _context5.sent;
            return _context5.abrupt("return", res);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _deleteUpload.apply(this, arguments);
}
//# sourceMappingURL=large-attachments.js.map